module.exports = __webpack_public_path__ + "static/media/GreenLogo.1171fc04.png";